import React from "react"
import { StyleSheet, View } from "react-native"
import { StatusBar } from "@common/systemBars/StatusBar"
import { ActivityIndicator } from "react-native"
import { theme } from "../theme/theme"
import TextM from "../components/text/TextM"

export const LoadingScreen = ({ bgColor = theme.colors.whiteAlmost, message }) => {
    const styles = StyleSheet.create({
        container: {
            flex: 1,
            backgroundColor: bgColor,
            alignItems: "center",
            justifyContent: "center",
            paddingHorizontal: 20,
            gap: 16,
        },
    })
    return (
        <View style={styles.container}>
            <ActivityIndicator
                animating={true}
                size="large"
                color={theme.colors.primary}
            />
            {message && (
                <TextM
                    color={theme.colors.grey}
                    fontSize={14}
                    center
                    wrap
                >
                    {message}
                </TextM>
            )}
            <StatusBar
                style="dark"
                backgroundColor={theme.colors.white}
                translucent={false}
            />
        </View>
    )
}
